module.exports = "/call-frontend/img/hero_logo.a45719ff.png";